<app-contact-documents [contact]="contact"></app-contact-documents>
<app-contact-biometrics-simple [contact]="contact"></app-contact-biometrics-simple>
<app-contact-editor [contact]="contact"></app-contact-editor>